var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountPayable(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 216,
    viewBox: "0 0 146 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddddd_5633_110480)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.3387 8.20703L59.2753 13.3666V23.6858L50.3387 28.8453L41.402 23.6858V13.3666L50.3387 8.20703Z",
    fill: "url(#paint0_linear_5633_110480)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3379 18.5247L59.2744 13.3672V23.6823L50.3379 28.8544L50.3379 18.5247Z",
    fill: "url(#paint1_linear_5633_110480)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3386 24.2031L55.2538 21.3654L55.2538 15.6898L50.3386 12.8521L45.4235 15.6898L45.4235 21.3654L50.3386 24.2031Z",
    fill: "url(#paint2_linear_5633_110480)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.3378 2.47656L64.2391 10.5025V26.5543L50.3378 34.5802L36.4365 26.5543V10.5025L50.3378 2.47656ZM36.9366 10.7912V26.2656L50.3378 34.0028L63.7391 26.2656V10.7912L50.3378 3.05397L36.9366 10.7912Z",
    fill: "#BEDCFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.3369,
    cy: 2.67287,
    rx: 1.54787,
    ry: 1.54787,
    fill: "#3290FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.3369,
    cy: 34.2705,
    rx: 1.54787,
    ry: 1.54787,
    fill: "#3290FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.9229,
    cy: 10.669,
    r: 1.54787,
    fill: "#3290FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.7529,
    cy: 10.669,
    rx: 1.54787,
    ry: 1.54787,
    fill: "#3290FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.9229,
    cy: 26.2783,
    rx: 1.54787,
    ry: 1.54787,
    fill: "#3290FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.7529,
    cy: 26.2783,
    rx: 1.54787,
    ry: 1.54787,
    fill: "#3290FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddddd_5633_110480",
    x: -48,
    y: 0,
    width: 196,
    height: 216,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.76726
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.1069
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.196078 0 0 0 0 0.564706 0 0 0 0 1 0 0 0 0.0899666 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5633_110480"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.6501
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.66004
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.196078 0 0 0 0 0.564706 0 0 0 0 1 0 0 0 0.129246 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5633_110480",
    result: "effect2_dropShadow_5633_110480"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12.5216
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.00862
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.196078 0 0 0 0 0.564706 0 0 0 0 1 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_5633_110480",
    result: "effect3_dropShadow_5633_110480"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 22.3363
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.93452
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.196078 0 0 0 0 0.564706 0 0 0 0 1 0 0 0 0.190754 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_5633_110480",
    result: "effect4_dropShadow_5633_110480"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 41.7776
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.711
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.196078 0 0 0 0 0.564706 0 0 0 0 1 0 0 0 0.230033 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_5633_110480",
    result: "effect5_dropShadow_5633_110480"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 100
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.196078 0 0 0 0 0.564706 0 0 0 0 1 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_5633_110480",
    result: "effect6_dropShadow_5633_110480"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_5633_110480",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5633_110480",
    x1: 50.3203,
    y1: 8.1574,
    x2: 51.8117,
    y2: 29.0254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3099FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D5CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5633_110480",
    x1: 51.3263,
    y1: 21.1244,
    x2: 54.8062,
    y2: 28.8544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003FD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A60DD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5633_110480",
    x1: 48.4979,
    y1: 14.3765,
    x2: 48.4979,
    y2: 24.2031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB2FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FAEFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountPayable);
export default __webpack_public_path__ + "static/media/accountPayable.cc61db8a3d66a7d9187012c5971293c3.svg";
export { ForwardRef as ReactComponent };